<template>
  <form
    v-on:submit.prevent="$route.name == 'ficha' ? false : saveForm()"
    novalidate
  >
    <LoaderContent v-if="isLoading" :welcomeMessage="false" />

    <div v-else>
      <div class="form-row">
        <InputAvatar
          v-if="showField('personal_data', 'avatar') && $route.name == 'ficha'"
          class="input-avatar-container"
        />

        <div
          class="form-group col-12 col-sm-6 col-md-4 pronoun-container mb-4"
          :class="{ 'is-invalid': $v.pronoun.$error }"
          v-if="showField('diversity', 'pronoun') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-pronoun' + _uid"
              ><span v-if="fieldIsRequired('diversity', 'pronoun')  || $route.name != 'ficha'">*</span>Pronome adequado para você?</label
            >
            <span
              class="btn btn-sm p-0 align-middle ml-1"
              @click="showModalDiversityInput()"
              ><icon-help-circle-outline
            /></span>
          </div>

          <selectize
            :id="'personal-input-pronoun' + _uid"
            :settings="pronounSettings"
            v-model="pronoun"
          >
            <option
              :value="pronoun.id"
              v-for="(pronoun, index) in $store.state.domains.pronouns"
              :key="index"
            >
              {{ pronoun.description }}
            </option>
          </selectize>
        </div>

        <div
          class="form-group col-12 col-sm-6 col-md-4 firstname-container mb-4"
          :class="{ 'is-invalid': $v.firstname.$error }"
        >
          <div>
            <label :for="'personal-input-first-name' + _uid"
              ><span>*</span> Nome</label
            >
          </div>

          <input
            type="text"
            class="form-control"
            :id="'personal-input-first-name' + _uid"
            v-model="firstname"
          />
        </div>

        <div
          class="form-group col-12 col-sm-6 col-md-4 lastname-container mb-4"
          :class="{ 'is-invalid': $v.lastname.$error }"
        >
          <div>
            <label :for="'personal-input-last-name' + _uid"
              ><span>*</span> Sobrenome</label
            >
          </div>

          <input
            type="text"
            class="form-control"
            :id="'personal-input-last-name' + _uid"
            v-model="lastname"
          />
        </div>

        <div
          class="form-group col-12 col-sm-6 col-md-4 socialName-container mb-4"
          :class="{ 'is-invalid': $v.socialName.$error }"
          v-if="showField('personal_data', 'social-name') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-social-name' + _uid"
              ><span v-if="fieldIsRequired('personal_data', 'social-name')">*</span>Nome social</label
            >
            <span
              class="btn btn-sm p-0 align-middle ml-1"
              @click="showModalDiversityInput()"
              ><icon-help-circle-outline
            /></span>
          </div>

          <input
            type="text"
            class="form-control"
            :id="'personal-input-social-name' + _uid"
            v-model="socialName"
          />
        </div>

        <div
          class="form-group col-12 col-sm-6 col-md-4 email-container mb-4"
          :class="{ 'is-invalid': $v.email.$error }"
          v-if="showField('personal_data', 'email') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-email' + _uid"
              ><span v-if="fieldIsRequired('personal_data', 'email') || $route.name != 'ficha'">*</span> E-mail</label
            >
          </div>

          <input
            type="email"
            class="form-control"
            :id="'personal-input-email' + _uid"
            v-model="email"
          />
        </div>

        <div
          class="form-group col-12 col-sm-6 col-md-4 phone-container mb-4"
          :class="{ 'is-invalid': $v.phone.$error }"
          v-if="showField('personal_data', 'cellphone') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-phone' + _uid"
              ><span v-if="fieldIsRequired('personal_data', 'cellphone') || $route.name != 'ficha'">*</span> Celular</label
            >
          </div>

          <the-mask
            type="tel"
            class="form-control"
            :id="'personal-input-phone' + _uid"
            :mask="['(##) ####-####', '(##) #####-####']"
            v-model="phone"
          />
          <small class="form-text text-danger" v-if="phoneMessage">{{
            phoneMessage
          }}</small>
        </div>

        <div
          class="form-group col-12 col-sm-6 col-md-4 raceAndEthnicity-container mb-4"
          :class="{ 'is-invalid': $v.raceAndEthnicity.$error }"
          v-if="showField('diversity', 'race_and_ethnicity') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-raceAndEthnicity' + _uid"
              ><span v-if="fieldIsRequired('diversity', 'race_and_ethnicity') || $route.name != 'ficha'">*</span> Raça/Etnia</label
            >
            <span
              class="btn btn-sm p-0 align-middle ml-1"
              @click="showModalDiversityInput()"
              ><icon-help-circle-outline
            /></span>
          </div>

          <selectize
            :id="'personal-input-raceAndEthnicity' + _uid"
            :settings="raceAndEthnicitySettings"
            v-model="raceAndEthnicity"
          >
            <option
              :value="raceAndEthnicity.id"
              v-for="(raceAndEthnicity, index) in $store.state.domains
                .race_and_ethnicities"
              :key="index"
            >
              {{ raceAndEthnicity.description }}
            </option>
          </selectize>
        </div>

        <div
          class="form-group col-12 col-sm-6 col-md-4 gender-container mb-4"
          :class="{ 'is-invalid': $v.gender.$error }"
          v-if="showField('diversity', 'gender') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-gender' + _uid"
              ><span v-if="fieldIsRequired('diversity', 'gender') || $route.name != 'ficha'">*</span> Sua identidade de gênero</label
            >
            <span
              class="btn btn-sm p-0 align-middle ml-1"
              @click="showModalDiversityInput()"
              ><icon-help-circle-outline
            /></span>
          </div>

          <selectize
            :id="'personal-input-gender' + _uid"
            :settings="genderSettings"
            v-model="gender"
          >
            <option
              :value="gender.id"
              v-for="(gender, index) in $store.state.domains.genders"
              :key="index"
            >
              {{ gender.description }}
            </option>
          </selectize>
        </div>

        <div
          class="form-group col-12 col-sm-6 col-md-4 sexualOrientation-container mb-4"
          :class="{ 'is-invalid': $v.sexualOrientation.$error }"
          v-if="showField('diversity', 'sexual_orientation') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-sexual-orientation' + _uid"
              ><span v-if="fieldIsRequired('diversity', 'sexual_orientation') || $route.name != 'ficha'">*</span> Orientação sexual</label
            >
            <span
              class="btn btn-sm p-0 align-middle ml-1"
              @click="showModalDiversityInput()"
              ><icon-help-circle-outline
            /></span>
          </div>

          <selectize
            :id="'personal-input-sexual-orientation' + _uid"
            :settings="sexualOrientationSettings"
            v-model="sexualOrientation"
          >
            <option
              :value="sexualOrientation.id"
              v-for="(sexualOrientation, index) in $store.state.domains
                .sexual_orientations"
              :key="index"
            >
              {{ sexualOrientation.description }}
            </option>
          </selectize>
        </div>

        <div
          class="form-group col-12 col-sm-6 col-md-4 birthday-container mb-4"
          :class="{ 'is-invalid': $v.birthday.$error }"
          v-if="showField('personal_data', 'birthday') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-birthday' + _uid"
              ><span v-if="fieldIsRequired('personal_data', 'birthday') || $route.name != 'ficha'">*</span> Data de nascimento</label
            >
          </div>

          <the-mask
            type="tel"
            class="form-control"
            :id="'personal-input-birthday' + _uid"
            :mask="'##/##/####'"
            :masked="true"
            v-model="birthday"
          />
          <small class="form-text text-danger" v-if="birthdayMessage">{{
            birthdayMessage
          }}</small>
        </div>

        <div
          class="form-group col-12 col-sm-6 col-md-4 nationality-container mb-4"
          :class="{ 'is-invalid': $v.nationality.$error }"
          v-if="showField('personal_data', 'personal_nationality') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-nationality' + _uid"
              ><span v-if="fieldIsRequired('personal_data', 'personal_nationality') || $route.name != 'ficha'">*</span> Nacionalidade</label
            >
          </div>

          <selectize
            :id="'personal-input-nationality' + _uid"
            :settings="nationalitySettings"
            v-model="nationality"
          >
            <option
              :value="country.name"
              v-for="(country, index) in $store.state.domains.countries"
              :key="index"
            >
              {{ country.name }}
            </option>
          </selectize>
        </div>

        <div
          class="form-group col-12 col-sm-6 col-md-4 document-container mb-4"
          :class="{ 'is-invalid': $v.cpf.$error || $v.passport.$error }"
          v-if="showField('personal_data', 'document') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-document' + _uid"
              ><span v-if="fieldIsRequired('personal_data', 'document') || $route.name != 'ficha'">*</span> {{ isForeign ? "RNE" : "CPF" }}</label
            >
          </div>

          <the-mask
            v-if="!isForeign"
            type="tel"
            class="form-control"
            :id="'personal-input-document' + _uid"
            mask="###.###.###-##"
            v-model="cpf"
            :readOnly="cpfReadOnly"
          />
          <input
            v-else
            type="text"
            class="form-control"
            :id="'personal-input-document' + _uid"
            v-model="passport"
            :readOnly="passportReadOnly"
          />
        </div>

        <div
          class="form-group col-12 col-sm-6 col-md-4 personalIncome-container mb-4"
          :class="{ 'is-invalid': $v.personalIncome.$error }"
          v-if="showField('diversity', 'personal_income') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-personalIncome' + _uid"
              ><span v-if="fieldIsRequired('diversity', 'personal_income') || $route.name != 'ficha'">*</span> Sua renda mensal</label
            >
            <span
              class="btn btn-sm p-0 align-middle ml-1"
              @click="showModalDiversityInput()"
              ><icon-help-circle-outline
            /></span>
          </div>

          <selectize
            :id="'personal-input-personalIncome' + _uid"
            :settings="personalIncomeSettings"
            v-model="personalIncome"
          >
            <option
              :value="personalIncome.id"
              v-for="(personalIncome, index) in $store.state.domains
                .personal_incomes"
              :key="index"
            >
              {{ personalIncome.description }}
            </option>
          </selectize>
        </div>

        <div
          class="form-group col-12 col-sm-6 col-md-4 familyIncome-container mb-4"
          :class="{ 'is-invalid': $v.familyIncome.$error }"
          v-if="showField('diversity', 'family_income') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-familyIncome' + _uid"
              ><span v-if="fieldIsRequired('diversity', 'family_income') || $route.name != 'ficha'">*</span> Sua renda familiar</label
            >
            <span
              class="btn btn-sm p-0 align-middle ml-1"
              @click="showModalDiversityInput()"
              ><icon-help-circle-outline
            /></span>
          </div>

          <selectize
            :id="'personal-input-familyIncome' + _uid"
            :settings="familyIncomeSettings"
            v-model="familyIncome"
          >
            <option
              :value="familyIncome.id"
              v-for="(familyIncome, index) in $store.state.domains
                .family_incomes"
              :key="index"
            >
              {{ familyIncome.description }}
            </option>
          </selectize>
        </div>

        <div
          class="form-group col-12 col-sm-6 col-md-4 marital-status-container mb-4"
          :class="{ 'is-invalid': $v.maritalStatus.$error }"
          v-if="showField('personal_data', 'marital_status') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-marital-status' + _uid"
              ><span v-if="fieldIsRequired('personal_data', 'marital_status')">*</span> Estado civil</label
            >
          </div>

          <selectize
            :id="'personal-input-marital-status' + _uid"
            :settings="maritalStatusSettings"
            v-model="maritalStatus"
          >
            <option
              :value="status.id"
              v-for="(status, index) in $store.state.domains.maritalStatus"
              :key="index"
            >
              {{ status.description }}
            </option>
          </selectize>
        </div>

        <FormQuestions
          class="col-12 form-questions-container"
          v-if="($route.name == 'ficha' || $route.name == 'banco-de-talentos') && showFormQuestions == true"
          id="form-questions"
        />

        <div
          class="col-12 row"
          v-if="showField('diversity', 'disability') || $route.name != 'ficha'"
        >
          <div class="form-group col-12 divider-container">
            <hr />
          </div>

          <div class="form-group col-12 d-flex flex-wrap disability-container mb-3">
            <div>
              <label class="mb-0 mr-3"><span v-if="fieldIsRequired('diversity', 'disability') || $route.name != 'ficha'">*</span> Possui alguma deficiência?</label>
            </div>

            <div id="personal-input-disability-container">
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  :id="'personal-input-disability-true' + _uid"
                  class="custom-control-input"
                  v-model="has_disability"
                  :value="true"
                />
                <label
                  class="custom-control-label"
                  :for="'personal-input-disability-true' + _uid"
                  >Sim</label
                >
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  :id="'personal-input-disability-false' + _uid"
                  class="custom-control-input"
                  v-model="has_disability"
                  :value="false"
                />
                <label
                  class="custom-control-label"
                  :for="'personal-input-disability-false' + _uid"
                  >Não</label
                >
              </div>
            </div>
          </div>

          <div class="form-group col-12 mb-4" v-show="has_disability == true">
            <div
              class="row mx-0 d-flex align-items-center justify-content-between"
            >
              <div
                class="col-12 col-sm-5 col-md-3 mb-2 custom-control custom-checkbox custom-control-inline"
                :class="{
                  'is-invalid': $v.disabilities.$error && has_disability == true
                }"
                v-for="(deficiency, index) in $store.state.domains.disabilities"
                :key="index"
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="'personal-input-disability-' + _uid + deficiency.id"
                  v-model="disabilities"
                  :value="deficiency.id"
                />
                <label
                  class="custom-control-label"
                  :for="'personal-input-disability-' + _uid + deficiency.id"
                  >{{ deficiency.name }}</label
                >
              </div>
            </div>
            <MedicalReport />
          </div>

          <div
            class="form-group col-12 d-flex flex-wrap"
            v-if="has_disability"
            id="personal-input-need-help-selection-process"
          >
            <div>
              <label class="mb-0 mr-3"
                >Você tem alguma necessidade de ajuda durante o processo de
                seleção?</label
              >
            </div>

            <div class="">
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  :id="'personal-input-need-help-selection-process-true' + _uid"
                  class="custom-control-input"
                  v-model="need_help_selection_process"
                  :value="true"
                />
                <label
                  class="custom-control-label"
                  :for="'personal-input-need-help-selection-process-true' + _uid"
                  >Sim</label
                >
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  type="radio"
                  :id="'personal-input-need-help-selection-process-false' + _uid"
                  class="custom-control-input"
                  v-model="need_help_selection_process"
                  :value="false"
                />
                <label
                  class="custom-control-label"
                  :for="'personal-input-need-help-selection-process-false' + _uid"
                  >Não</label
                >
              </div>
            </div>
          </div>

          <div class="form-group col-12 mb-4" v-if="need_help_selection_process">
            <textarea
              type="text"
              class="form-control"
              v-model="description_help_selection_process"
              placeholder="Digite aqui algum suporte especial que sua característica como PCD demande durante a participação no recrutamento (ex.: descrição de texto em áudios, aumento de tamanho dos textos, etc.)"
              :id="'personal-input-description_help_selection_process' + _uid"
              rows="5"
              maxlength="100"
            ></textarea>
            <span
              :class="
                description_help_selection_process.length == '100'
                  ? 'limiter'
                  : ''
              "
            >
              <small> {{ caharactersLeft }} </small>
            </span>
          </div>
        </div>

        <div class="form-group col-12 divider-container">
          <hr />
        </div>

        <div
          class="form-group col-12 col-md-4 zipcode-container mb-4"
          :class="{ 'is-invalid': $v.zipcode.$error }"
          v-if="showField('address', 'cep') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-zip-code' + _uid"
              ><span v-if="fieldIsRequired('address', 'cep') || $route.name != 'ficha'">*</span> CEP</label
            >
          </div>

          <the-mask
            type="tel"
            class="form-control"
            :id="'personal-input-zip-code' + _uid"
            :mask="'#####-###'"
            v-model="zipcode"
            @keyup.native="getAddress()"
          />
        </div>

        <div
          class="form-group col-12 col-md-4 street-container mb-4"
          :class="{ 'is-invalid': $v.street.$error }"
          v-if="showField('address', 'street') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-street' + _uid"
              ><span v-if="fieldIsRequired('address', 'street') || $route.name != 'ficha'">*</span> Rua</label
            >
          </div>
          <input
            type="text"
            class="form-control"
            :id="'personal-input-street' + _uid"
            v-model="street"
          />
        </div>

        <div
          class="form-group col-12 col-md-4 number-container mb-4"
          :class="{ 'is-invalid': $v.number.$error }"
          v-if="showField('address', 'number') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-number' + _uid"
              ><span v-if="fieldIsRequired('address', 'number') || $route.name != 'ficha'">*</span> Número</label
            >
          </div>
          <input
            type="text"
            class="form-control"
            :id="'personal-input-number' + _uid"
            v-model="number"
          />
        </div>

        <div
          class="form-group col-12 col-md-4 complement-container mb-4"
          v-if="showField('address', 'complement') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-complement' + _uid"><span v-if="fieldIsRequired('address', 'complement') || $route.name != 'ficha'">*</span> Complemento</label>
          </div>
          <input
            type="text"
            class="form-control"
            :id="'personal-input-complement' + _uid"
            v-model="complement"
          />
        </div>

        <div
          class="form-group col-12 col-md-4 neighborhood-container mb-4"
          :class="{ 'is-invalid': $v.neighborhood.$error }"
          v-if="showField('address', 'neighborhood') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-neighborhood' + _uid"
              ><span v-if="fieldIsRequired('address', 'neighborhood') || $route.name != 'ficha'">*</span> Bairro</label
            >
          </div>

          <input
            type="text"
            class="form-control"
            :id="'personal-input-neighborhood' + _uid"
            v-model="neighborhood"
          />
        </div>

        <div
          class="form-group col-12 col-md-4 state-container mb-4"
          :class="{ 'is-invalid': $v.state.$error }"
          v-if="showField('address', 'state') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-state' + _uid"
              ><span v-if="fieldIsRequired('address', 'state') || $route.name != 'ficha'">*</span> Estado</label
            >
          </div>

          <selectize
            :id="'personal-input-state' + _uid"
            :settings="stateSettings"
            v-model="state"
          >
            <option
              :value="state.id"
              v-for="(state, index) in $store.state.domains.states"
              :key="index"
            >
              {{ state.name }}
            </option>
          </selectize>
        </div>

        <div
          class="form-group col-12 col-md-4 city-container mb-4"
          :class="{ 'is-invalid': $v.city.$error }"
          v-if="showField('address', 'city') || $route.name != 'ficha'"
        >
          <div>
            <label :for="'personal-input-city' + _uid"
              ><span v-if="fieldIsRequired('address', 'city') || $route.name != 'ficha'">*</span> Cidade</label
            >
          </div>
          <selectize
            :id="'personal-input-city' + _uid"
            :settings="citySettings"
            v-model="city"
          >
            <option
              :value="$helpers.cleanStringToCompare(city.name)"
              v-for="(city, index) in $store.state.domains.cities"
              :key="index"
            >
              {{ $helpers.toTitle(city.name) }}
            </option>
          </selectize>
        </div>

        <div class="form-group col-12 divider-container">
          <hr />
        </div>

        <div
          class="form-group col-12 resume-container mb-4"
          :class="{ 'is-invalid': $v.whatDoYouLove.$error }"
           v-if="showField('personal_data', 'what_do_you_love') || $route.name != 'ficha'"
          >
          <div>
            <label :for="'personal-input-resume' + _uid"
              ><span v-if="fieldIsRequired('personal_data', 'what_do_you_love')">*</span> Tem algo mais que você considera importante contar sobre
              você?</label
            >
          </div>
          <textarea
            type="text"
            class="form-control"
            placeholder="Escreva aqui um resumo com destaque as características relevantes para atenção dos recrutadores."
            :id="'personal-input-resume' + _uid"
            rows="5"
            v-model="whatDoYouLove"
          ></textarea>
        </div>
      </div>

      <p class="small text-right font-italic">Campos com * são obrigatórios.</p>

      <div class="d-flex align-items-center mt-4" v-if="hasButtons">
        <button type="reset" class="btn btn-light mr-auto" @click="reset()">
          Cancelar
        </button>
        <button type="submit" class="btn btn-blue-ml">Salvar</button>
      </div>
    </div>
  </form>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, requiredIf } from 'vuelidate/lib/validators';
import IconHelpCircleOutline from 'vue-material-design-icons/HelpCircleOutline.vue';
import InputAvatar from '../Media/InputAvatar.vue';
import LoaderContent from '../Loader/LoaderContent.vue';
import FormQuestions from '../Questions/FormQuestions.vue';
import MedicalReport from './MedicalReport.vue';

export default {
  name: 'FormPersonalData',
  data() {
    return {
      firstname: '',
      lastname: '',
      socialName: '',
      email: '',
      nationality: 'Brasil',
      document_label: 'CPF',
      cpf: '',
      cpfReadOnly: false,
      passport: '',
      passportReadOnly: false,
      gender: '',
      sexualOrientation: '',
      raceAndEthnicity: '',
      pronoun: '',
      personalIncome: '',
      familyIncome: '',
      maritalStatus: '',
      phone: '',
      birthday: '',
      has_disability: false,
      disabilities: [],
      need_help_selection_process: false,
      description_help_selection_process: '',
      medical_report: '',
      zipcode: '',
      street: '',
      number: '',
      complement: '',
      neighborhood: '',
      state: '',
      city: '',
      whatDoYouLove: '',
      birthdayMessage: null,
      phoneMessage: null,
      nationalitySettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      genderSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      sexualOrientationSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      raceAndEthnicitySettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      pronounSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      personalIncomeSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      maritalStatusSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      familyIncomeSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      stateSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
        onChange: (value) => {
          this.state = value;
          this.$store.dispatch(
            'graphql_queries/query',
            `domains(state: "${
              this.$store.state.domains.states.find((st) => st.id == value).abbr
            }") {
                cities {id, name, abbr},
            }`,
          );
        },
      },
      citySettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: 'body',
      },
      isLoading: false,
      source: 'chatbot',
    };
  },

  props: {
    hasButtons: {
      type: Boolean,
      default: false,
    },

    storeByEventBus: {
      type: Boolean,
      default: false,
    },
    showFormQuestions: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    caharactersLeft() {
      const char = this.description_help_selection_process.length;
      const limit = 100;
      return `${limit - char} / ${limit}`;
    },

    isForeign() {
      return !(
        this.nationality
        && this.nationality.toLowerCase().indexOf('brasil') != -1
      );
    },
  },

  watch: {
    has_disability(newValue) {
      if (!newValue || newValue == false) {
        this.disabilities = [];
      }
    },
  },

  mixins: [validationMixin],

  validations: {
    firstname: {
      required,
    },
    lastname: {
      required,
    },
    socialName: {
      required: requiredIf(function () {
        return this.fieldIsRequired('personal_data', 'social-name')
      }),
    },
    email: {
      required: requiredIf(function () {
        return this.fieldIsRequired('personal_data', 'email') || this.$route.name != 'ficha'
      }),
    },
    nationality: {
      required: requiredIf(function () {
        return this.fieldIsRequired('personal_data', 'personal_nationality') || this.$route.name != 'ficha'
      }),
    },
    cpf: {
      required: requiredIf(function () {
        return (this.fieldIsRequired('personal_data', 'document') || this.$route.name != 'ficha') && !this.isForeign
      }),
    },
    passport: {
      required: requiredIf(function () {
        return (this.fieldIsRequired('personal_data', 'document') || this.$route.name != 'ficha') && this.isForeign
      }),
    },
    phone: {
      required: requiredIf(function () {
        return this.fieldIsRequired('personal_data', 'cellphone') || this.$route.name != 'ficha'
      }),
      isValid: (value, _this) => {
        if ( !_this.$v.required ) return true;

        if (!value) {
          _this.phoneMessage = 'Número inválido';
          return false;
        }

        const regex = new RegExp('^((1[1-9])|([2-9][0-9]))((3[0-9]{3}[0-9]{4})|(9[0-9]{3}[0-9]{5}))$');

        if (regex.test(value)) {
          _this.phoneMessage = null;
          return true;
        }

        _this.phoneMessage = 'Número inválido';
        return false;
      },
    },
    birthday: {
      required: requiredIf(function () {
        return this.fieldIsRequired('personal_data', 'birthday') || this.$route.name != 'ficha'
      }),
      isDate: (value, _this) => {
        if ( !_this.$v.required ) return true;

        const year = value.split('/')[2];
        const current_year = new Date().getFullYear(); // ano atual
        const age = current_year - year;

        if (age < 10) {
          _this.birthdayMessage = 'Data inválida';
          return false;
        }

        if (age > 100) {
          _this.birthdayMessage = 'Data inválida';
          return false;
        }

        if (
          _this.$moment(`${value.split('/').reverse().join('-')}`).isValid()
          == false
        ) {
          _this.birthdayMessage = 'Data inválida';
          return false;
        }

        _this.birthdayMessage = null;
        return true;
      },
    },
    gender: {
      required: requiredIf(function () {
        return this.fieldIsRequired('diversity', 'gender') || this.$route.name != 'ficha'
      }),
    },
    sexualOrientation: {
      required: requiredIf(function () {
        return this.fieldIsRequired('diversity', 'sexual_orientation') || this.$route.name != 'ficha'
      }),
     },
    raceAndEthnicity: {
      required: requiredIf(function () {
        return this.fieldIsRequired('diversity', 'race_and_ethnicity') || this.$route.name != 'ficha'
      }),
     },
    pronoun: {
      required: requiredIf(function () {
        return this.fieldIsRequired('diversity', 'pronoun')  || this.$route.name != 'ficha'
      }),
     },
    personalIncome: {
      required: requiredIf(function () {
        return this.fieldIsRequired('diversity', 'personal_income') || this.$route.name != 'ficha'
      }),
    },
    familyIncome: {
      required: requiredIf(function () {
        return this.fieldIsRequired('diversity', 'family_income') || this.$route.name != 'ficha'
      }),
    },
    maritalStatus: {
      required: requiredIf(function () {
        return this.fieldIsRequired('personal_data', 'marital_status')
      }),
    },
    zipcode: {
      required: requiredIf(function () {
        return this.fieldIsRequired('address', 'cep') || this.$route.name != 'ficha'
      }),
    },
    street: {
      required: requiredIf(function () {
        return this.fieldIsRequired('address', 'street') || this.$route.name != 'ficha'
      }),
    },
    number: {
      required: requiredIf(function () {
        return this.fieldIsRequired('address', 'number') || this.$route.name != 'ficha'
      }),
    },
    complement: {
      required: requiredIf(function () {
        return this.fieldIsRequired('address', 'complement') || this.$route.name != 'ficha'
      }),
    },
    neighborhood: {
      required: requiredIf(function () {
        return this.fieldIsRequired('address', 'neighborhood') || this.$route.name != 'ficha'
      }),
    },
    state: {
      required: requiredIf(function () {
        return this.fieldIsRequired('address', 'state') || this.$route.name != 'ficha'
      }),
    },
    city: {
      required: requiredIf(function () {
        return this.fieldIsRequired('address', 'city') || this.$route.name != 'ficha'
      }),
    },
    has_disability: {
      required: requiredIf(function () {
        return this.fieldIsRequired('diversity', 'disability') || this.$route.name != 'ficha'
      }),
    },
    disabilities: {
      required: requiredIf(function (value) {
        return this.has_disability == true;
      }),
    },
    description_help_selection_process: {},
    whatDoYouLove: {
      required: requiredIf(function () {
        return this.fieldIsRequired('personal_data', 'what_do_you_love')
      }),
    },
  },

  components: {
    InputAvatar,
    LoaderContent,
    FormQuestions,
    MedicalReport,
    IconHelpCircleOutline,
  },

  mounted() {
    setTimeout(() => this.removeAutoFillSelectize(), 500);
    this.getPersonalData();
  },

  destroyed() {
    this.$EventBus.$off('editingPersonalData');
    this.$EventBus.$off('storePersonalDataForm');
    this.$store.commit('PERSONAL_DATA_FORM', {});
    this.$store.commit('user/SET_FORMSTRUCT', 'reset')
  },

  methods: {
    showModalDiversityInput() {
      this.$EventBus.$emit('showModalDiversityInputs', 'modal-personal-data');
    },

    getPersonalData() {
      this.isLoading = true;
      let requestDomainReturn = '';
      let requestFormStruct = '';

      if(this.$route.name == 'ficha'){
        const opportunityId = this.$route.params.id.match(/\d+/)[0];
        requestFormStruct = `formStruct(opportunityId: ${opportunityId})`
      }

      if (this.$store.state.domains.countries.length == 0) {
        requestDomainReturn += 'countries { id, name },';
      }
      if (this.$store.state.domains.maritalStatus.length == 0) {
        requestDomainReturn += 'maritalStatus {id, description},';
      }
      if (this.$store.state.domains.states.length == 0) {
        requestDomainReturn += 'states { id, name, abbr },';
      }
      if (this.$store.state.domains.education_levels.length == 0) {
        requestDomainReturn += 'educationLevels {id, description},';
      }
      if (this.$store.state.domains.education_periods.length == 0) {
        requestDomainReturn += 'educationPeriods {id, description},';
      }
      if (this.$store.state.domains.education_status.length == 0) {
        requestDomainReturn += 'educationStatus {id, description},';
      }
      if (this.$store.state.domains.companies.length == 0) {
        requestDomainReturn += 'companies {id, name},';
      }
      if (this.$store.state.domains.professional_experience_areas.length == 0) {
        requestDomainReturn += 'professionalExperienceAreas {id, name},';
      }
      if (
        this.$store.state.domains.professional_experience_levels.length == 0
      ) {
        requestDomainReturn += 'professionalExperienceLevels {id, name}';
      }
      if (this.$store.state.domains.cause_experience_areas.length == 0) {
        requestDomainReturn += 'causeExperienceAreas {id, description},';
      }
      if (this.$store.state.domains.language_proficiencies.length == 0) {
        requestDomainReturn += 'languageProficiencies {id, description},';
      }

      requestDomainReturn += 'genders { id, description },';
      requestDomainReturn += 'raceAndEthnicities { id, description },';
      requestDomainReturn += 'pronouns { id, description },';
      requestDomainReturn += 'personalIncomes { id, description },';
      requestDomainReturn += 'familyIncomes { id, description },';
      requestDomainReturn += 'sexualOrientations {id, description},';
      requestDomainReturn += 'disabilities { id, name },';

      if (requestDomainReturn.length > 0) {
        requestDomainReturn = `domains {
          ${requestDomainReturn}
        },`;
      }

      this.$store
        .dispatch(
          'graphql_queries/query',
          `${requestDomainReturn}
          ${requestFormStruct}
          user( id: "${this.$store.state.user.profile.id}" ){
            avatar,
            medicalReports {
              id,
              name,
              file
            },
            profile{
              firstname,
              lastname,
              socialName,
              email,
              nationality,
              cpf,
              passport,
              gender,
              maritalStatus,
              phone,
              birthday,
              raceAndEthnicity,
              pronoun,
              sexualOrientation,
              personalIncome,
              familyIncome,
              descriptionHelpSelectionProcess,
              needHelpSelectionProcess,

              location {
                zipcode,
                street,
                number,
                complement,
                neighborhood,
                stateId,
                city
              },

              hasDisability,

              disabilities {
                disabilityId,
                name
              },

              educations {
                id,
                institutionName,
                level,
                courseName,
                startDate,
                endDate,
                stateId
              },

              professionalExperiences {
                id,
                role,
                responsabilities,
                company,
                startYear,
                endYear
              },

              languageProficiencies {
                id,
                language,
                proficiency
              },

              additionalQuestions {
                id,
                question,
                answer,
                slug
              },

              preSubscription {
                details
              }
            }
          }`,
        )
        .then(async (response) => {
          setTimeout(() => this.setPersonalDataFields(), 1000);
        });
    },

    setPersonalDataFields() {
      this.isLoading = true;
      const { profile } = this.$store.state.user;

      this.firstname = profile.firstname;
      this.lastname = profile.lastname;
      this.socialName = profile.socialName;
      this.email = profile.email;
      this.nationality = profile.nationality
        ? profile.nationality
        : profile.passport
          ? ''
          : 'Brasil';
      this.cpf = profile.cpf;
      this.cpfReadOnly = this.cpf != null && this.cpf.length > 0;
      this.passport = profile.passport;
      this.passportReadOnly = this.passport != null && this.passport.length > 0;
      this.gender = profile.gender;
      this.raceAndEthnicity = profile.raceAndEthnicity;
      this.pronoun = profile.pronoun;
      this.familyIncome = profile.familyIncome;
      this.personalIncome = profile.personalIncome;
      this.sexualOrientation = profile.sexualOrientation;
      this.maritalStatus = profile.maritalStatus;
      this.phone = profile.phone;
      this.birthday = this.$moment(profile.birthday).format('DD/MM/YYYY');
      this.disabilities = profile.disabilities.map(
        (disability) => disability.disabilityId,
      );
      this.has_disability = profile.hasDisability || this.disabilities.length > 0;
      this.whatDoYouLove = profile.whatDoYouLove;
      this.need_help_selection_process = profile.needHelpSelectionProcess || false;
      this.description_help_selection_process = profile.descriptionHelpSelectionProcess || '';
      if (profile.location) {
        this.zipcode = profile.location.zipcode;
        this.street = profile.location.street;
        this.number = profile.location.number;
        this.complement = profile.location.complement;
        this.neighborhood = profile.location.neighborhood;
        this.state = profile.location.stateId;
        if (this.state) {
          this.$store
            .dispatch(
              'graphql_queries/query',
              `domains(state: "${
                this.$store.state.domains.states.find(
                  (st) => st.id == this.state,
                ).abbr
              }") {
                  cities {id, name, abbr},
                }`,
            )
            .then(() => {
              this.city = this.$helpers.cleanStringToCompare(
                profile.location.city,
              );
            });
        }
      }

      this.$EventBus.$on('storePersonalDataForm', this.storeForm);
      this.isLoading = false;
    },

    reset(closeModal = true) {
      this.isLoading = false;
      this.$v.$reset();
      if (closeModal) this.$emit('closeModal');
      Object.assign(this.$data, this.$options.data.call(this));
      this.setPersonalDataFields();
    },

    getAddress() {
      if (this.zipcode != null && this.zipcode.replace(/\D/g, '').length != 8) {
        return false;
      }

      this.$store
        .dispatch('location/addressByZipCode', this.zipcode)
        .then((address) => {
          this.street = address.logradouro;
          this.number = '';
          this.complement = '';
          this.neighborhood = address.bairro;
          this.state = this.$store.state.domains.states.find(
            (st) => st.abbr.toUpperCase() == address.uf.toUpperCase(),
          ).id;
          this.$store
            .dispatch(
              'graphql_queries/query',
              `domains(state: "${
                this.$store.state.domains.states.find(
                  (st) => st.id == this.state,
                ).abbr
              }") {
              cities {id, name, abbr},
            }
          `,
            )
            .then(() => {
              this.city = this.$helpers.cleanStringToCompare(
                address.localidade,
              );
            });
        });
    },

    // Salva o formulário no banco de dados e retorna o perfil atualizado
    saveForm() {
      const data = this.$data;

      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.dispatch('user/personalDataUpdate', data).then((response) => {
        if (response.error) {
          this.$swal(
            'Uoops',
            'Ocorreu um erro ao salvar suas informações',
            'error',
          );
        } else {
          this.$store
            .dispatch(
              'graphql_queries/query',
              `user( id: "${this.$store.state.user.profile.id}" ){
                profile{
                  firstname,
                  lastname,
                  socialName,
                  email,
                  nationality,
                  cpf,
                  passport,
                  gender,
                  sexualOrientation,
                  raceAndEthnicity,
                  pronoun,
                  personalIncome,
                  maritalStatus,
                  phone,
                  birthday,
                  whatDoYouLove,
                  familyIncome,
                  descriptionHelpSelectionProcess,
                  needHelpSelectionProcess,
                  location {
                    zipcode,
                    street,
                    number,
                    complement,
                    neighborhood,
                    stateId,
                    city
                  },
                  disabilities {
                    disabilityId,
                    name
                  },
                }
              }`,
            )
            .then(() => {
              this.$swal(
                'Pronto!',
                'Dados pessoais salvo com sucesso',
                'success',
              );
              this.reset();
            });
        }
      });
    },

    // Salva o formulário localmente para poder salvar na API em algum momento futuro do fluxo
    storeForm() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$store.commit('PERSONAL_DATA_FORM', {
          error: true,
        });

        setTimeout(() => {
          Array.from(this.$el.querySelectorAll('.is-invalid')).some((field) => {
            field.querySelector('input').focus();
            return field;
          });
        }, 100);
      } else {
        this.$store.commit('PERSONAL_DATA_FORM', {
          data: this.$data,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
